// extracted by mini-css-extract-plugin
module.exports = {"menu":"recardCenter_menu__3xcn4"};